import { Component, Inject } from '@angular/core'
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatButtonModule } from '@angular/material/button'

@Component({
  selector: 'app-create-work-order-remark-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
  ],
  templateUrl: './create-work-order-remark-dialog.component.html',
})
export class CreateWorkOrderRemarkDialogComponent {
  remarkForm: FormGroup

  constructor(
    public dialogRef: MatDialogRef<CreateWorkOrderRemarkDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { quotationId: number },
  ) {
   this.remarkForm = this.fb.group({
  purchaseOrderNumber: [null],
  remarks: [null],
})
  }

  onCancel(): void {
    this.dialogRef.close()
  }

  onSubmit(): void {
  if (this.remarkForm.valid) {
    this.dialogRef.close(this.remarkForm.value)
  }
}
}
